<template>
	<article class="public-order-page">
		<!-- 合作商户信息 -->
		<publicBusinessInfo :businessImgUrl="businessInfo.LogoUrl == '' ? businessImgUrl : businessInfo.LogoUrl" :businessName="businessInfo.CompanyName"></publicBusinessInfo>

		<section :class="['inputs_wrap']">
			<div class="user-info-input">
				<span>
					<i class="iconfont icon-location2 red-text"></i>
					出发地
				</span>
				<input
					readonly="true"
					@click="isGo ? selectstartAddress() : selectEndAddress()"
					class="start-address"
					placeholder="请选择出发地址"
					type="text"
					:value="isGo ? (DefaultAddress ? DefaultAddress.District + '-' + DefaultAddress.Address : '') : endAddress"
				/>
			</div>

			<!-- 交换btn -->
			<div @click="changeStartEnd" class="exchange text-center">
				<button class="exchange-btn"><i class="iconfont icon-exchange2jiaohuan"></i></button>
			</div>

			<div class="user-info-input">
				<span>
					<i class="iconfont icon-location2 primaryColor-text"></i>
					目的地
				</span>
				<input
					readonly="true"
					@click="isGo ? selectEndAddress() : selectstartAddress()"
					class="end-address"
					placeholder="请选择目的地址"
					type="text"
					:value="isGo ? endAddress : DefaultAddress ? DefaultAddress.District + '-' + DefaultAddress.Address : ''"
				/>
			</div>

			<div class="user-info-input date-picker" @click="selectSetDate">
				<!-- <em style="color: #E22222;">*</em> -->
				<span>
					<i class="iconfont icon-riqixuanze gray-text"></i>
					乘车日期
				</span>
				<span :class="[setDate == '' ? 'gray-text' : '']">{{ setDate == '' ? '请选择预订日期' : setDate }}</span>
			</div>

			<div class="user-info-input time-picker" @click="setDateTime">
				<span>
					<i class="iconfont icon-shijian"></i>
					期望时间
				</span>
				<span :class="[setTime == '' ? 'gray-text' : '']">{{ setTime == '' ? '请选择用车时间' : setTime }}</span>
			</div>
		</section>

		<p class="notice reservation_service_notice red_color flex_wrap a_i_center" @click="showWarningTips">
			<i class="iconfont icon-gantanhao"></i>
			<span>旗妙出行约车须知</span>
		</p>

		<div class="btn_wrap big-btn"><button class="save_btn" @click="gotoOrderPage">确认地址路线</button></div>

		<section class="btn_wrap">
			<img style="vertical-align: middle;text-align: center; width: 150px; height: 150px;" src="/../static/img/youtoqrcode.jpg" />
			<p class="text-center red-text">请先长按关注公众号以便接收订单消息推送</p>
		</section>

		<!--服务协议弹出层 Start  -->
		<transition :name="transitionName" mode="out-in">
			<article v-show="showMask" class="mask_wrap" @click.self="showWarningTips">
				<!-- <section :class="['mask_container_wrap',showMask?'scale_up':'']"> -->
				<transition name="scale_up" mode="out-in">
					<section v-if="showMask" :class="['mask_container_wrap']">
						<div class="mask_article_wrap">
							<h3 class="article_title red_color">接送车服务须知</h3>
							<!-- <p class="p_title">一、注意事项</p> -->
							<p class="red-text">*当天12:30以前的班车接送，在乘车前一天下午17:00左右通知实际接送乘车时间</p>
							<p class="red-text">*当天12:30以后的班车接送，在乘车当天早上10:00左右通知实际接送乘车时间</p>

							<p class="p_title">一、预约接送服务需至少提前一天在[中山市旅游集散中心]公众号上提前购买。</p>
							<div style="text-align: center;">
								<img style="vertical-align: middle;text-align: center;" src="/../static/img/youtoqrcode.jpg" />
								<p class="text-center red-text">请先长按关注公众号以便接收订单消息推送</p>
							</div>
							<p class="p_title">
								二、请旅客收到接送时间后，提前到达接送地点，并保持电话畅通。若您所提供的电话号码长时间处于无人接听、忙音等状况而使我们不能及时联系到您，由此造成的损失，均由旅客本人负责。
							</p>
							<p class="p_title">
								三、由于旅客自身原因，未能准时到达预约地点的，且未提前联系客服0760-88880777说明原因的，逾时5分钟后视为自动放弃接送服务，接送费用照收，不作另外退还，非司机原因（如堵车、他人责任的交通事故等）造成旅客的延误或其他损失，我方不承担相应的责任。
							</p>
							<p class="p_title">四、服务车型为5座轿车，服务价格以我司移动端现行公示为准，旅客在我们的页面查看相关服务的价格。现行服务价格标准如下：</p>

							<div class="table xingli">
								<ul class="tr bg_th_orderinfo">
									<li class="th">起/止地</li>
									<li class="th">价格[{{ isGo ? '去程' : '返程' }}]</li>
									<!-- <li class="th">包车价格/车</li> -->
								</ul>
								<ul v-for="(item, key, index) in priceTable" :key="index" class="tr">
									<li class="td">{{ item.District }}</li>
									<li class="td">{{ item.singlePrice }}/人</li>
									<!-- <li class="td">{{ item.doublePrice }}元/车</li> -->
								</ul>
							</div>
							<p class="text-center red-text">2人8折、3人7折、4人6折。</p>
							<p class="text-center red-text">注：以上价格随时可能更新，具体以页面公示最新价格标准为准。</p>

							<p class="">A. 单人或2-3人购买接送服务，沿途拼车，同一订单同一地址视为1单接送，每车4位乘客为上限。</p>
							<p class="">B. 4人购买接送服务，同一订单同一地址视为包车接送.</p>
							<p class="p_title">五、行李件数：</p>
							<p class="">
								拼车每人可免费携带26寸以下行李1件(4人同一订单同一地址视为包车,行李总数不超4件)，超出行李（26寸以上按2件计算）按10元/件收取费用，若行李较多可在下单前电话咨询。
							</p>
							<p class="p_title">
								六、接送服务在未安排车辆和未通知接送时间前，旅客取消接送，不收取接送费；若已安排接送车辆并通知接送时的，由于旅客个人原因，需要取消接送服务的，视为自动放弃接送服务，不作另外退还。
							</p>
							<p class="p_title">
								七、旅客不得携带危险品或者其他法律、法规规定禁止或不适宜携带的物品搭乘车辆驾驶员的车辆，否则车辆驾驶员有权拒绝提供服务,并由旅客承担任何携带该等物品引起的后果和责任。
							</p>
							<p class="p_title">八、旅客不得在不乘坐车辆的情况下,委托驾驶员单独运送物品。</p>
							<p class="p_title">
								九、旅客不得在使用服务过程中进行违反平台规则的不文明的行为(包括吸烟、喝酒、吐痰、辱骂或殴打驾驶员) ,
								不得进行或要求车辆驾驶员进行违反相关交通规则或者其他法律法规的行为，因旅客违反禁止行为的原因导致有关部门行政处罚、人员受伤、发生交通事故、造成车辆损坏或其他损失的,旅客应向受损方进行赔偿
							</p>
							<p class="p_title">
								十、旅客应当具备完全民事行为能力(年满18周岁或年满16周岁、以自己的劳动收入为主要生活来源,且精神健康能完全辨认自己的行为) ,
								同时,旅客应当保证发布出行信息时是自愿的,且不存在意识不清楚、醉酒等情形。若旅客有意识不清楚、醉酒等情形的，陪同人员代为发布的出行需求信息视为旅客的行为;；在旅客醉酒或存在其他意识不清楚的情况下,应当由意识清楚的第三方陪同;；在旅客饮酒、醉酒或意识不清楚的情况下,给他人造成损失的,旅客本人应当就相应损失予以赔偿。
							</p>
						</div>
					</section>
				</transition>
			</article>
		</transition>
		<!--服务协议弹出层 End -->

		<article :class="isShowMap ? 'mask_wrap flex_wrap a_i_center j_c_center mask_show' : 'mask_wrap flex_wrap a_i_center j_c_center'" v-if="isShowMap">
			<section :class="isShowMap ? 'mask_container_mapwrap reservation_service scale_up' : 'mask_container_mapwrap reservation_service'" v-if="isShowMap">
				<i class="iconfont icon-shanchu1" @click="closeConfirmView"></i>
				<div class="weui-cells weui-cells_form"><h2 class="article_title red_color">请确认行程线路</h2></div>

				<div ref="allMap" id="allMap" v-show="isShowMap"></div>

				<div class="weui-cells weui-cells_form">
					<div class="weui-cell">
						<div class="weui-cell__hd">时长约：{{ duration }}分钟/路程约：{{ kilos }}公里</div>
					</div>
					<div class="weui-cell">
						<!-- <div class="weui-cell__hd">
							估算价：{{ estimatedAmount }}元； &nbsp;&nbsp;&nbsp;会员价：{{
								selectedPickupPriceModel ? (isGo ? selectedPickupPriceModel.Price + '元' : selectedPickupPriceModel.BackPrice + '元') : '暂无数据！'
							}}
						</div>	 -->
						<div class="weui-cell__hd">
							计算价：{{ estimatedAmount }}元；
						</div>
					</div>
				</div>

				<div class="btn_wrap"><button class="btn inquire_btn" @click="confirmAddress">确 认 无 误</button></div>
			</section>
		</article>
	</article>
</template>

<script>
import businessApi from '@/request/businessApi';
import appointApi from '@/request/appointApi';
import addressApi from '@/request/addressApi';
import salesApi from '@/request/salesApi';

import Header from './child-components/Header';
import Swiper from './child-components/Swiper';
import publicBusinessInfo from './child-components/publicBusinessInfo';
import InputInfo from './child-components/InputInfo';

import baseTool from '@/utils/baseFunction';

//引入vuex下mapState模块,该模块作用为方便调用state数据,语法糖
import { mapState } from 'vuex';

export default {
	data() {
		return {
			startAddress: '',
			endAddress: '',
			businessInfo: {},
			businessImgUrl: '/../static/img/news.gif',
			businessName: '中山港客运码头',
			businessAddressList: [],
			setDate: baseTool.dateFormat(new Date(), 'yyyy-MM-dd'),
			// setTime: baseTool.dateFormat(new Date(), 'HH:mm'),
			setTime: '',
			isGo: true,
			pickupPriceList: [],
			priceTable: [],
			showMask: false,
			transitionName: 'tanchu',
			//合作商户信息:
			name: 'zspassenger',
			avableShowFrequencyTime: '',
			avableShowPickupFrequencyTime: '',
			avableBuyBackPickupTime: '',
			isShowMap: false,
			map: null,
			estimatedAmount: '',
			duration: 0,
			kilos: 0,
			selectedPickupPriceModel: null,
			qrcodeUrl: '../static/img/youtoqrcode.jpg',
			noLimit: false,
			todayAfterSixHour: '',
			nowTime: '',
			fromParams: '',
			myTimer: null
		};
	},
	activated() {
		let that = this;
		//每次加载页面触发
		//通过dispatch调用ticket下actions异步函数中方法,最终改变state里面数据,
		// 第一个参数为方法路径,第二个参数为该方法的实参
		this.computedAvableTime();
		this.tmpTimer = setInterval(() => {
			if (this.$store.state.user.OpenId && this.$store.state.user.OpenId.length > 0) {
				clearInterval(this.tmpTimer);
				// this.$store.dispatch('ticket/getDefaultAddress', this.$store.state.user.OpenId);
				addressApi.getAddressList(this.$store.state.user.OpenId, '').then(sucRes => {
					let result = sucRes;
					if (result.success && result.data.length > 0) {
						for (let i = 0; i < result.data.length; i++) {
							if (result.data[i].IsDefault) {
								this.$store.commit('ticket/setDefaultAddress', result.data[i]);
								this.getPickupPriceList();
								break;
							}
						}
					} else {
						alert('请先添加接送地址信息');
						this.selectstartAddress();
					}
				});

				if (this.$route.params.from && this.$route.params.from.length) {
					this.fromParams = this.$route.params.from;
					salesApi.firstBinding(this.fromParams, this.$store.state.user.OpenId).then(sucRes => {
						console.log(sucRes);
					});
				}
			}
		}, 500);

		// this.myTimer = setInterval(() => {
		//   console.log(this.myTimer);
		//   if (this.DefaultAddress != null) {
		//     clearInterval(this.myTimer);
		//     this.myTimer = null;
		//     this.getPickupPriceList();
		//   }
		// }, 500);

		if (this.$route.params.name && this.$route.params.name.length) {
			this.name = this.$route.params.name;
			//根据标识获取商户信息
			this.getBusinessInfo();
			//获取商户列表
			this.getBusinessAddressList();
		}

		if (this.$route.params.back && this.$route.params.back.length) {
			if (this.$route.params.back === 'back') {
				this.isGo = false;
				this.$store.commit('appoint/setData', {
					isGo: this.isGo
				});
				let tmpDate = new Date();
				tmpDate.setTime(tmpDate.getTime() + 130 * 60 * 1000);
				this.setTime = baseTool.dateFormat(tmpDate, 'HH:mm');
			}
		}
		if (this.$route.params.limit && this.$route.params.limit.length) {
			if (this.$route.params.limit === 'nolimit') {
				this.noLimit = true;
				let tmpDate = new Date();
				tmpDate.setTime(tmpDate.getTime() + 10 * 60 * 1000);
				this.setTime = baseTool.dateFormat(tmpDate, 'HH:mm');
			}
		}
		if (this.$route.params.from && this.$route.params.from.length) {
			this.fromParams = this.$route.params.from;
		}
	},
	components: {
		'hq-header': Header,
		'public-order-input': InputInfo,
		Swiper,
		publicBusinessInfo
	},
	methods: {
		computedAvableTime() {
			var that = this;
			this.avableShowFrequencyTime = baseTool.formatterDateTime(new Date());
			var todayTenHour = baseTool.formatterDate(new Date()) + ' 10:00';
			this.todayAfterSixHour = baseTool.formatterDate(new Date()) + ' 17:00';
			this.nowTime = baseTool.formatterDateTime(new Date());
			var val = baseTool.compareDateEndTimeGTStartTime(this.nowTime, todayTenHour); // nowTime=2018-11-12 15:04比较todayTenHour=2018-11-12 10:00 false
			var val2 = baseTool.compareDateEndTimeGTStartTime(this.nowTime, this.todayAfterSixHour); // nowTime=2018-11-12 15:04比较todayAfterSixHour=2018-11-12 18:00 true

			if (val) {
				// 仍然未过当天10点，则下午1点以后的所有班次都可以显示
				this.avableShowPickupFrequencyTime = baseTool.formatterDate(new Date()) + ' 12:30';
			} else if (val2) {
				// 仍然未过当天下午6点，则可以查看隔天的全部接送班次，当天则不可以。
				this.avableShowPickupFrequencyTime = baseTool.addDate(new Date(), 1) + ' 01:00';
			} else {
				this.avableShowPickupFrequencyTime = baseTool.addDate(new Date(), 1) + ' 12:30';
			}
			// console.log('avableShowFrequencyTime->', this.avableShowFrequencyTime);
			// console.log('avableShowPickupFrequencyTime->', this.avableShowPickupFrequencyTime);
		},
		selectstartAddress() {
			this.$router.push({
				name: 'MyAddressManager',
				params: {
					mode: 'choose'
				}
			});
		},
		getBusinessInfo() {
			//获取商户信息
			businessApi.getBusinessInfo(this.name).then(res => {
				if (res.success) {
					this.businessInfo = res.data;
					this.$store.commit('appoint/setData', { businessSign: this.name }); // new
				}
			});
		},
		getBusinessAddressList() {
			//获取商户地址列表
			businessApi.getBusinessAddressList(this.name).then(res => {
				// console.log(res);
				if (res.success) {
					this.businessAddressList = res.data;
					console.log(this.businessAddressList);
					this.businessAddressList.forEach(item => {
						if (item.IsDefault) {
							this.endAddress = item.MarkName;
							this.$store.commit('appoint/setData', {
								MarkName: item.MarkName, // new
								bookingEndAddr: item.Address,
								bookingEndPointLo: item.Longitude,
								bookingEndPointLa: item.Latitude
							});
							// this.getPickupPriceList();
						}
					});
				}
			});
		},
		getPickupPriceList() {
			this.pickupPriceList = [];
			this.$Spin.show();
			businessApi.getBusinessPickupPriceList(this.name, this.$store.state.appoint.MarkName).then(sucRes => {
				this.$Spin.hide();
				if (sucRes.success && sucRes.data.length > 0) {
					this.pickupPriceList = sucRes.data;
					for (let i = 0; i < this.pickupPriceList.length; i++) {
						if (this.pickupPriceList[i].District === this.DefaultAddress.District) {
							this.selectedPickupPriceModel = this.pickupPriceList[i];
							break;
						}
					}
					this.makePriceTable();
				} else {
					this.$Message.warning('没有该点的接送报价！');
				}
			});
		},
		// 生成价格表
		makePriceTable() {
			let tmpPriceArr = [];
			this.priceTable = [];
			for (let i = 0; i < this.pickupPriceList.length; i++) {
				if (this.pickupPriceList[i].Status) {
					if (this.isGo) {
						let tmpPrice = this.pickupPriceList[i].Price;
						if (tmpPriceArr.indexOf(tmpPrice) == -1) tmpPriceArr.push(tmpPrice);
					} else {
						let tmpPrice = this.pickupPriceList[i].BackPrice;
						if (tmpPriceArr.indexOf(tmpPrice) == -1) tmpPriceArr.push(tmpPrice);
					}
				}
			} // 生成价格数组
			tmpPriceArr.sort((val1, val2) => {
				return val1 - val2;
			});
			for (let i = 0; i < tmpPriceArr.length; i++) {
				let tmpDistrictStr = '';
				for (let j = 0; j < this.pickupPriceList.length; j++) {
					if (this.isGo) {
						if (this.pickupPriceList[j].Price == tmpPriceArr[i]) tmpDistrictStr += this.pickupPriceList[j].District + '、';
					} else {
						if (this.pickupPriceList[j].BackPrice == tmpPriceArr[i]) tmpDistrictStr += this.pickupPriceList[j].District + '、';
					}
				}
				tmpDistrictStr = tmpDistrictStr.substring(0, tmpDistrictStr.length - 1);
				let priceComputedDescription = '';
				priceComputedDescription += Math.round(tmpPriceArr[i]) + '/1人 ';
				priceComputedDescription += Math.round(tmpPriceArr[i] * 2 * 0.8) + '/2人 ';
				priceComputedDescription += Math.round(tmpPriceArr[i] * 3 * 0.7) + '/3人 ';
				priceComputedDescription += Math.round(tmpPriceArr[i] * 4 * 0.6) + '/4人';
				var tmpObj = { District: tmpDistrictStr, singlePrice: tmpPriceArr[i], doublePrice: tmpPriceArr[i] * 2, priceComputedDescription: priceComputedDescription };
				this.priceTable.push(tmpObj);
			}
		},
		showWarningTips() {
			this.showMask = !this.showMask;
		},
		selectEndAddress() {
			//选择商户地址列表
			let addressList = [];
			let that = this;
			console.log(this.businessAddressList);
			if (this.businessAddressList.length) {
				for (let i = 0; i < this.businessAddressList.length; i++) {
					let addressLiatTmp = {
						label: this.businessAddressList[i].MarkName,
						value: this.businessAddressList[i].MarkName
					};
					addressList.push(addressLiatTmp);
				}
			}
			this.$weui.picker(addressList, {
				onConfirm: result => {
					this.endAddress = result[0].value;
					let tmp = null;
					this.businessAddressList.forEach(item => {
						if (item.MarkName == this.endAddress) {
							tmp = item;
						}
					});
					console.log(tmp);
					this.$store.commit('appoint/setData', {
						MarkName: tmp.MarkName, // new
						bookingEndAddr: tmp.Address,
						bookingEndPointLo: tmp.Longitude,
						bookingEndPointLa: tmp.Latitude
					});
					this.getPickupPriceList();
				}
			});
		},
		changeStartEnd() {
			//对调
			this.isGo = !this.isGo;
			this.$store.commit('appoint/setData', {
				isGo: this.isGo
			});
			this.makePriceTable();
		},
		selectSetDate() {
			//日期
			let that = this;
			this.$weui.datePicker({
				start: new Date(), // 从今天开始
				end: baseTool.addDate(new Date(), 60),
				// defaultValue: startDate,
				onConfirm: result => {
					// that.submitInfo.bookDate = result[0].value + "-" + result[1].value + "-" + result[2].value;
					this.setDate = result[0].value + '-' + result[1].value + '-' + result[2].value;
					if (this.setTime != '') {
						this.$store.commit('appoint/setData', {
							bookingDate: this.setDate + ' ' + this.setTime
						});
					}
				}
			});
		},
		setDateTime() {
			//时间
			let _this = this;
			// var hours = [],
			//   minutes = [],
			//   symbol = [
			//     {
			//       label: ':',
			//       value: 0
			//     }
			//   ];
			// if (!hours.length) {
			//   for (let i = 4; i <= 21; i++) {
			//     var hours_item = {};
			//     hours_item.label = ('' + i).length === 1 ? '0' + i : '' + i;
			//     hours_item.value = i;
			//     hours.push(hours_item);
			//   }
			// }
			// minutes = [
			//   { label: '00', value: '00' },
			//   { label: '10', value: '10' },
			//   { label: '20', value: '20' },
			//   { label: '30', value: '30' },
			//   { label: '40', value: '40' },
			//   { label: '50', value: '50' }
			// ];
			let tmpArray = [
				{ label: '05:00', value: '05:00' },
				{ label: '06:00', value: '06:00' },
				{ label: '07:00', value: '07:00' },
				{ label: '08:00', value: '08:00' },
				{ label: '09:00', value: '09:00' },
				{ label: '10:00', value: '10:00' },
				{ label: '10:30', value: '10:30' },
				{ label: '11:00', value: '11:00' },
				{ label: '11:30', value: '11:30' },
				{ label: '12:00', value: '12:00' },
				{ label: '12:30', value: '12:30' },
				{ label: '13:00', value: '13:00' },
				{ label: '13:30', value: '13:30' },
				{ label: '14:00', value: '14:00' },
				{ label: '14:30', value: '14:30' },
				{ label: '15:00', value: '15:00' },
				{ label: '15:30', value: '15:30' },
				{ label: '16:00', value: '16:00' },
				{ label: '16:30', value: '16:30' },
				{ label: '17:00', value: '17:00' },
				{ label: '17:30', value: '17:30' },
				{ label: '18:00', value: '18:00' },
				{ label: '18:30', value: '18:30' },
				{ label: '19:00', value: '19:00' },
				{ label: '19:30', value: '19:30' },
				{ label: '20:00', value: '20:00' }
			];
			this.$weui.picker(tmpArray, {
				onConfirm: result => {
					// this.setTime = result[0].label + ':' + result[2].label;
					this.setTime = result[0].value;
					if (this.setDate != '') {
						this.$store.commit('appoint/setData', {
							bookingDate: this.setDate + ' ' + this.setTime
						});
					}
				}
			});
		},
		checkInput() {
			if (this.setDate == '' || this.setTime == '') {
				this.$Message.warning('次日12:30分前接送服务，需提前一天17:00分前购买，当天12:30分后的接送服务，需于当天10:00前购买。');
				return false;
			}
			let bookingDate = this.setDate + ' ' + this.setTime;
			if (this.isGo) {
				// 去程接送时间验证
				let canPickup = baseTool.compareDateEndTimeGTStartTime(this.avableShowPickupFrequencyTime, bookingDate);
				if (!canPickup) {
					alert('次日12:30分前接送服务，需提前一天17:00分前购买，当天12:30分后的接送服务，需于当天10:00前购买。');
					return false;
				} else return true;
			} else {
				// 返程接送时间验证
				if (this.noLimit)
					// 若传入无须验证时间，则直接通过回程购买。
					return true;
				else {
					// 需要验证时间
					let isAfterSix = baseTool.compareDateEndTimeGTStartTime(baseTool.formatterDateTime(new Date()), this.todayAfterSixHour); // nowTime=2018-11-12 15:04比较todayAfterSixHour=2018-11-12 18:00 true
					// 当天下午6点前
					if (isAfterSix) {
						// 验证bookingDate是否距当前时间2小时以上
						let isAboveTowHour = baseTool.compareDateEndTimeGTStartTime(baseTool.addHour(new Date(), 2), bookingDate);
						console.log('isAboveTowHour=>', isAboveTowHour);
						if (isAboveTowHour) return true;
						else {
							alert('回程接送需在当天18:00前提前2小时购买。');
							return false;
						}
					} else {
						// 当天下午6点后
						let canPickup = baseTool.compareDateEndTimeGTStartTime(this.avableShowPickupFrequencyTime, bookingDate);
						if (!canPickup) {
							alert('当天17:30后不能再购买当天的回程接送。');
							return false;
						} else return true;
					}
				}
			}
		},
		gotoOrderPage() {
			let that = this;
			//跳转
			// new
			let checked = this.checkInput();
			if (!checked) {
				return;
			}
			if (this.DefaultAddress.Address != '') {
				this.$Spin.show();

				appointApi.convertAddressToLocation(this.DefaultAddress.City, this.DefaultAddress.Address).then(sucRes => {
					if (sucRes.status == '1' && sucRes.info == 'OK' && sucRes.pois && sucRes.pois.length > 0) {
						console.log('sucRes=>', sucRes);
						this.$Spin.hide();
						let location = sucRes.pois[0].location;
						appointApi.convertLocationToAddress(location).then(sucRes2 => {
							console.log('sucRes2=>', sucRes2);
							if (sucRes2.status == '1' && sucRes2.info == 'OK') {
								let district = sucRes2.regeocode.addressComponent.township;
								let addressStr = sucRes2.regeocode.formatted_address;
								if (this.DefaultAddress.District != district) {
									alert(
										`当前地址所选行政区[${this.DefaultAddress.District}-${
											this.DefaultAddress.Address
										}]与地图计算行政区结果[${district}-${addressStr}]不符，不能进行正确计费，请致电0760-88880777反映相关情况，或更改相关地址信息后重试。`
									);
								} else {
									that.$store.commit('appoint/setData', {
										bookingStartAddr: that.DefaultAddress.Address,
										bookingStartPointLa: location.split(',')[1],
										bookingStartPointLo: location.split(',')[0],
										bookingDate: that.setDate + ' ' + that.setTime
									});
									that.getFarePrediction(that.DefaultAddress.Address, location.split(',')[1], location.split(',')[0]);
									that.showConfirmView();
								}
							}
						});
					} else {
						this.$Message.warning('当前地址计算座标失败！');
					}
				});
			} else {
				this.$Message.warning('请选择接送地址');
				this.selectstartAddress();
			}
		},
		closeConfirmView() {
			this.isShowMap = false;
		},
		showConfirmView() {
			let that = this;
			let startAddr = this.isGo ? this.DefaultAddress.Address : this.endAddress;
			let startCity = this.isGo ? this.DefaultAddress.City : this.$store.state.appoint.CityName;
			let endAddr = this.isGo ? this.endAddress : this.DefaultAddress.Address;
			let endCity = this.isGo ? this.$store.state.appoint.CityName : this.DefaultAddress.City;

			this.isShowMap = true;
			this.$nextTick(() => {
				that.map = new AMap.Map('allMap', {
					resizeEnable: true, //是否监控地图容器尺寸变化
					zoom: 18 //初始化地图层级
					// center: [116.397428, 39.90923] //初始化地图中心点
				});
				//构造路线导航类
				let driving = new AMap.Driving({
					map: that.map
					// panel: 'panel'
				});
				// 根据起终点名称规划驾车导航路线
				driving.search([{ keyword: startAddr, city: startCity }, { keyword: endAddr, city: endCity }], (status, result) => {
					// result 即是对应的驾车导航信息，相关数据结构文档请参考  https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
					if (status === 'complete' && result.info === 'OK') {
						console.log(result);
						let time = result.routes[0].time;
						let distance = result.routes[0].distance;
						this.duration = Math.round(time / 60);
						this.kilos = Math.round(distance / 1000);
					} else {
						console.log('获取驾车数据失败：' + result);
					}
				});
			});
		},
		getFarePrediction(bookingStartAddr, bookingStartPointLa, bookingStartPointLo) {
			let that = this;
			let postData = {
				bookingDate: this.$store.state.appoint.bookingDate,
				serviceType: this.$store.state.appoint.serviceType,
				bookingStartAddr: this.isGo ? bookingStartAddr : this.endAddress,
				bookingStartPointLo: this.isGo ? bookingStartPointLo : this.$store.state.appoint.bookingEndPointLo,
				bookingStartPointLa: this.isGo ? bookingStartPointLa : this.$store.state.appoint.bookingEndPointLa,
				bookingEndAddr: this.isGo ? this.endAddress : bookingStartAddr,
				bookingEndPointLo: this.isGo ? this.$store.state.appoint.bookingEndPointLo : bookingStartPointLo,
				bookingEndPointLa: this.isGo ? this.$store.state.appoint.bookingEndPointLa : bookingStartPointLa,
				city: this.$store.state.appoint.CityName
			};
			appointApi.getFarePrediction(postData).then(sucRes => {
				if (sucRes.success && sucRes.data.amounts && sucRes.data.amounts.length > 0) this.estimatedAmount = Math.round(sucRes.data.amounts[0].amount * 1.5);
				else this.estimatedAmount = '计价失败！';
			});
		},
		confirmAddress() {
			let that = this;
			this.closeConfirmView();
			this.$router.push({
				name: 'makeappointorderpage',
				params: {
					limit: that.noLimit ? 'nolimit' : 'limit',
					from: that.fromParams,
					eprice: that.estimatedAmount
				}
			});
		}
	},
	//使用mapState模块映射数据
	computed: mapState({
		DefaultAddress: state => state.ticket.DefaultAddress,
		bookingDate: state => state.appoint.bookingDate
	})
};
</script>

<style scoped lang="less">
@import '../style/public';

.public-order-page {
	justify-content: initial;
	.business-info {
		background-color: #fff;
		border-bottom-left-radius: 10px;
		border-bottom-right-radius: 10px;
	}
	.notice {
		.blockPadding(0, 0.5rem);
		.red-text;
	}
}

.inputs_wrap {
	width: 90%;
	margin: 0.5rem auto;
	background-color: #fff;
	position: relative;
	.shadow(10px, 0, 0, rgba(0, 0, 0, 0.4));
	.radius;
	.blockPadding(0, 0.4rem);

	.user-info-input {
		.flex_wrap(initial, center);
		.blockPadding(0.3rem, 0);
		padding-left: 0.2rem;
		&:first-child {
			margin-right: 1rem;
		}
		& .iconfont {
			margin-right: 5px;
			font-size: 0.4rem;
		}
		& > span {
			padding-right: 10px;
		}

		& > span:first-child {
			// .border-R;
			.flex_items(auto, 0, 0);
			text-align: left;
		}

		& > input,
		& > span:last-child {
			border: none;
			background-color: transparent;
			.blockPadding(0, 10px);
		}

		// &>span:last-child{}
	}
	.exchange {
		position: absolute;
		.wh(1.2rem, 1.2rem);
		.flex_wrap(center, center);
		top: 0.65rem;
		right: 0.6rem;
	}

	.text-center {
		& > button {
			margin: 0 auto;
		}
	}

	& > .user-info-input:nth-last-child(n + 2) {
		.border-B(1px, solid);
	}
}

.btn_wrap {
	text-align: center;
	.margin-Tb(0.3rem, 0);
}
.big-btn {
	button {
		width: 90%;
		.btn();
		.radius;
		.primarybtnColor;
		.shadow(8px);
	}
}

.exchange-btn {
	position: relative;
	background-color: transparent;
	width: 0.7rem;
	height: 0.7rem;
	.shadow(5px);

	& > i {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-45%, -50%);
		font-size: 0.4rem;
		color: #fff;
		text-shadow: 0 0 5px #E77618;
		z-index: 2;
	}

	text-align: center;
	// .flex_wrap(center,center);
	// background-color: #E7761852;
	.radius(50%);
	.btn;

	&:after {
		content: '';
		display: block;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: #E77618;
		opacity: 0.8;
		z-index: 1;
		.radius(50%);
	}
}

#panel {
	position: fixed;
	background-color: white;
	max-height: 90%;
	overflow-y: auto;
	top: 10px;
	right: 10px;
	width: 280px;
}
#panel .amap-call {
	background-color: #009cf9;
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
}
#panel .amap-lib-driving {
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
	overflow: hidden;
}
#allMap {
	width: 100%;
	height: 50%;
	max-height: 50%;
}

/*iconfont*/
.mask_container_mapwrap {
	width: 100%;
	height: 90%;
	overflow: scroll;
	margin: auto;
	border-radius: 10px;
	background-color: #fff;
	transform: scale(0);
	transition: all 0.4s;
	padding: 3%;
	position: absolute;
}

.j_c_center {
	justify-content: center;
}
.a_i_center {
	align-items: center;
}
.flex_wrap {
	display: flex !important;
}
.mask_show {
	z-index: 100;
	opacity: 1;
}
.mask_show > .scale_up {
	transform: scale(1);
}
.btn_wrap {
	width: 100%;
	text-align: center;
	margin: 1em 0;
}
.btn {
	padding: 0 3%;
	text-indent: 5px;
	letter-spacing: 5px;
	font: 600 0.4rem/1rem '微软雅黑';
	border-radius: 5px;
	border: 1px solid #888;
	box-shadow: 0 0 5px #586c94;
	margin: 5px auto;
}
.article_title {
	font-size: 0.5rem;
	text-align: center;
	line-height: 6vh;
	font-weight: 600;
}
.red_color {
	color: #e22222;
}
</style>



// WEBPACK FOOTER //
// src/components/AppointCarPage.vue